import { useQuery } from '@tanstack/react-query'
import { Route, Routes } from 'react-router'
import { api } from './api/client'
import Anmeldung from './seiten/Anmeldung'
import Buero from './seiten/Buero'
import Ergebnis from './seiten/Ergebnis'
import ErfassungNeu from './seiten/ErfassungNeu'
import ErfassungUebersicht from './seiten/ErfassungUebersicht'
import FachAufnahme from './seiten/FachAufnahme'
import FachBestaetigen from './seiten/FachBestaetigen'
import Report from './seiten/Report'
import SchrankDetail from './seiten/SchrankDetail'
import SchrankGesamtfoto from './seiten/SchrankGesamtfoto'
import SchrankListe from './seiten/SchrankListe'
import SchrankNeu from './seiten/SchrankNeu'
import SonderfallDetail from './seiten/SonderfallDetail'
import SonderfallEbene from './seiten/SonderfallEbene'
import SonderfallGesamtfoto from './seiten/SonderfallGesamtfoto'
import SonderfallNeu from './seiten/SonderfallNeu'
import NichtGefunden from './seiten/NichtGefunden'
import Start from './seiten/Start'
import Verwaltung from './seiten/Verwaltung'
import VersorgungspunktNeu from './seiten/VersorgungspunktNeu'

interface Anmeldestatus {
  angemeldet: boolean
  benutzername: string
}

export default function App() {
  // Der Statusaufruf ist oeffentlich und setzt nebenbei das CSRF-Cookie.
  const status = useQuery({
    queryKey: ['anmeldestatus'],
    queryFn: () => api.get<Anmeldestatus>('/api/auth/status'),
  })

  if (status.isPending) {
    return (
      <div className="app">
        <main className="koerper">
          <div className="spinner" />
        </main>
      </div>
    )
  }

  if (!status.data?.angemeldet) {
    return <Anmeldung />
  }

  return (
    <Routes>
      <Route path="/" element={<Start />} />
      <Route path="/erfassungen/neu" element={<ErfassungNeu />} />
      <Route path="/erfassungen/:erfassungId" element={<ErfassungUebersicht />} />
      <Route path="/erfassungen/:erfassungId/versorgungspunkt-neu" element={<VersorgungspunktNeu />} />
      <Route path="/erfassungen/:erfassungId/buero" element={<Buero />} />
      <Route path="/erfassungen/:erfassungId/ergebnis" element={<Ergebnis />} />
      <Route path="/erfassungen/:erfassungId/report" element={<Report />} />
      <Route path="/versorgungspunkte/:vpId" element={<SchrankListe />} />
      <Route path="/versorgungspunkte/:vpId/schrank-neu" element={<SchrankNeu />} />
      {/* P7-04: Sonderfälle hängen am Versorgungspunkt, genau wie Schränke. */}
      <Route path="/versorgungspunkte/:vpId/sonderfall-neu" element={<SonderfallNeu />} />
      <Route path="/sonderfaelle/:sonderfallId" element={<SonderfallDetail />} />
      <Route path="/sonderfaelle/:sonderfallId/gesamtfoto" element={<SonderfallGesamtfoto />} />
      <Route path="/sonderfaelle/:sonderfallId/ebenen/:ebeneNr" element={<SonderfallEbene />} />
      <Route path="/schraenke/:schrankId" element={<SchrankDetail />} />
      <Route path="/schraenke/:schrankId/gesamtfoto" element={<SchrankGesamtfoto />} />
      <Route path="/schraenke/:schrankId/aufnahme/:fachNr" element={<FachAufnahme />} />
      <Route path="/faecher/:fachId/bestaetigen" element={<FachBestaetigen />} />
      <Route path="/verwaltung" element={<Verwaltung />} />
      <Route path="*" element={<NichtGefunden />} />
    </Routes>
  )
}
